import { openBlock as c, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M1.917 13.333c0 .415.335.75.75.75h10.666a.75.75 0 0 0 0-1.5H3.417V2.667a.75.75 0 1 0-1.5 0v10.666Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M6.742 3.912c.21-.28.53-.512.967-.512.47 0 .75.356.883.574.154.25.275.57.376.9.19.619.356 1.422.519 2.206l.037.183c.18.863.357 1.692.566 2.321.105.316.207.549.302.699a.862.862 0 0 0 .065.091c.07-.056.17-.174.29-.381.241-.423.471-1.057.675-1.78a.6.6 0 0 1 1.155.325c-.21.75-.473 1.498-.79 2.051-.157.275-.352.543-.595.734-.256.201-.6.338-.993.25-.4-.088-.66-.393-.821-.648a4.463 4.463 0 0 1-.427-.963c-.235-.708-.426-1.608-.602-2.455-.01-.055-.022-.109-.033-.162-.167-.808-.322-1.557-.495-2.118a3.944 3.944 0 0 0-.182-.493c-.05.095-.104.232-.158.422-.137.479-.225 1.106-.324 1.808l-.041.296c-.112.783-.246 1.645-.499 2.314-.241.642-.703 1.383-1.61 1.393a.6.6 0 0 1-.013-1.2c.106-.001.291-.061.5-.616.199-.526.319-1.255.434-2.06l.04-.29c.097-.687.198-1.408.359-1.974.092-.323.219-.654.415-.915Zm.788.632a.04.04 0 0 1-.009-.008l.009.008Zm2.885 5.86.001-.001Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  l,
  n
];
function r(d, s) {
  return c(), t("svg", o, [...a]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
